/*eslint-disable react/jsx-no-target-blank */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from 'react';
import Authenticated from '../../shared/Authenticated';
import './footer.scss';
import Links from './Links';
import Skeleton from './Skeleton';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import {
  FacebookSVG,
  TwitterSVG,
  LinkedinSVG,
  YoutubeSVG,
} from '../../img/FooterSVG';
import Appstore from '../../img/Appstore.svg';
import Googleplay from '../../img/googleplay.svg';
import { useLocation } from 'react-router-dom';
import httpheader from 'src/Member/shared/httpheader';
library.add(faExclamationCircle);

export default function PublicFooter() {
  const {
    isContantInfoLoaded,
    contactInfo,
    isLinksLoaded,
    linksInfo,
    isMediaLinksLoaded,
    mediaLinksInfo,
  } = useSelector((state) => state.footer);
  const { branding } = useSelector((state) => state.theme);
  const [isLogin, setLogin] = useState(false);
  const [isLoginPage, setLoginPage] = useState(false);
  const [isFooterDisabled, setFooterDisabled] = useState(false);
  const [displayStayConnected, setdisplayStayConnected] = useState(false);
  const [displaygetMobileApp, setdisplaygetMobileApp] = useState(false);
  const location = useLocation();
  const mediaLinks = Object.values(mediaLinksInfo);
  const { pathname } = useLocation();
  const customClass = pathname.includes('/member/cost-estimator')
    ? 'footer-cost-estimator'
    : '';

  useEffect(() => {
    setdisplayStayConnected(false);
    setdisplaygetMobileApp(false);
    if (!location.pathname.includes('/member/')) {
      setLoginPage(true);
    } else {
      setLoginPage(false);
    }

    if (
      location.pathname.includes('/member/page/') &&
      location.search.includes('&newTab')
    ) {
      setFooterDisabled(true);
    } else {
      setFooterDisabled(false);
    }

    if (mediaLinks) {
      if (
        mediaLinksInfo?.Facebook?.URL == '' &&
        mediaLinksInfo?.Twitter?.URL == '' &&
        mediaLinksInfo?.YouTube?.URL == '' &&
        mediaLinksInfo?.LinkedIn?.URL == ''
      ) {
        setdisplayStayConnected(true);
      }
      if (
        mediaLinksInfo?.iPhone?.URL == '' &&
        mediaLinksInfo?.Android?.URL == ''
      ) {
        setdisplaygetMobileApp(true);
      }
    }
  }, [location.pathname, mediaLinks]);

  return (
    <div role="contentinfo">
      <div className={`footer ${customClass}`}>
        {!isFooterDisabled && (
          <Container>
            <Row>
              {!isContantInfoLoaded && <Skeleton count={5} />}
              {isContantInfoLoaded && Object.keys(contactInfo)?.length > 0 ? (
                <Col md={4} lg={4} sm={12} xs={12} className="width-100">
                  <h3>Contact Us</h3>
                  <p>
                    {contactInfo?.Description && (
                      <Fragment>
                        {contactInfo?.Description} <br></br>
                      </Fragment>
                    )}
                    {contactInfo?.Phone1 && (
                      <a
                        className="text-muted"
                        href={'tel:' + contactInfo?.Phone1}
                      >
                        {' '}
                        {contactInfo?.Phone1}{' '}
                      </a>
                    )}
                    {contactInfo?.Phone1 && contactInfo?.Phone2 && (
                      <>
                        {' '}
                        <span aria-label="or">|</span>{' '}
                      </>
                    )}
                    {contactInfo?.Phone2 && (
                      <a
                        className="text-muted"
                        href={'tel:' + contactInfo?.Phone2}
                      >
                        {contactInfo?.Phone2}{' '}
                      </a>
                    )}
                  </p>
                  <Row>
                    <Col>
                      {contactInfo?.Email && (
                        <p>
                          <span>Email</span> :{' '}
                          <a href={'mailto:' + contactInfo?.Email}>
                            {contactInfo?.Email}
                          </a>
                        </p>
                      )}
                      {contactInfo?.Address && (
                        <p className="w-60">{contactInfo?.Address}</p>
                      )}
                    </Col>
                  </Row>
                </Col>
              ) : null}
              <Col md={4} lg={4} sm={6} xs={12} className="width-100">
                {!isLinksLoaded && <Skeleton count={5} />}
                {isLinksLoaded && Object.keys(linksInfo)?.length > 0 ? (
                  <>
                    <Row>
                      <Links blockId="1" />
                      <Links blockId="2" />
                    </Row>
                  </>
                ) : (
                  isLinksLoaded && (
                    <>
                      <Row>
                        <h3>Links</h3>
                        <p>
                          Currently we are unable to get Links information
                          please try after sometime
                        </p>
                      </Row>
                    </>
                  )
                )}
              </Col>
              <Col md={4} lg={4} sm={6} xs={12} className="width-100">
                <Row>
                  {!isLinksLoaded && <Skeleton count={5} />}
                  {isLinksLoaded && linksInfo && <Links blockId="3" />}
                  <Col md={6} lg={6} sm={6} xs={6}>
                    <Row>
                      <Col>
                        {!isMediaLinksLoaded && <Skeleton count={5} />}
                        {isMediaLinksLoaded &&
                        Object.keys(mediaLinksInfo)?.length > 0 &&
                        !displayStayConnected ? (
                          <>
                            <h3>Stay Connected</h3>
                            <ListGroup horizontal className="social-icons">
                              {mediaLinksInfo?.Facebook?.URL && (
                                <>
                                  <ListGroup.Item>
                                    <a
                                      href={mediaLinksInfo?.Facebook?.URL}
                                      target="_blank"
                                      alt="facebook"
                                      title="Facebook"
                                    >
                                      <FacebookSVG />
                                    </a>
                                  </ListGroup.Item>
                                </>
                              )}
                              {mediaLinksInfo?.Twitter?.URL && (
                                <>
                                  <ListGroup.Item>
                                    <a
                                      href={mediaLinksInfo?.Twitter?.URL}
                                      target="_blank"
                                      alt="Twitter"
                                      title="Twitter"
                                    >
                                      {/*<i className="fab fa-twitter"></i> */}
                                      <TwitterSVG />
                                    </a>
                                  </ListGroup.Item>
                                </>
                              )}
                              {mediaLinksInfo?.YouTube?.URL && (
                                <>
                                  <ListGroup.Item>
                                    <a
                                      href={mediaLinksInfo?.YouTube?.URL}
                                      target="_blank"
                                      alt="YouTube"
                                      title="YouTube"
                                    >
                                      {/*<i className="fab fa-youtube"></i> */}
                                      <YoutubeSVG />
                                    </a>
                                  </ListGroup.Item>
                                </>
                              )}
                              {mediaLinksInfo?.LinkedIn?.URL && (
                                <>
                                  <ListGroup.Item>
                                    <a
                                      href={mediaLinksInfo?.LinkedIn?.URL}
                                      target="_blank"
                                      alt="LinkedIn"
                                      title="LinkedIn"
                                    >
                                      {/*<i className="fab fa-linkedin-square"></i> */}
                                      <LinkedinSVG />
                                    </a>
                                  </ListGroup.Item>
                                </>
                              )}
                            </ListGroup>
                          </>
                        ) : null}
                      </Col>
                    </Row>
                    {!isLoginPage && (
                      <Row>
                        {httpheader.getCNAME().includes('mybenefits') ||
                        httpheader.getCNAME().includes('roundstone') ? (
                          <></>
                        ) : (
                          <Col>
                            {!isMediaLinksLoaded && <Skeleton count={5} />}
                            {isMediaLinksLoaded &&
                              mediaLinksInfo &&
                              !displaygetMobileApp && (
                                <>
                                  <h3 className="mt-0">Get the Mobile App</h3>
                                  <p className="app-icon">
                                    {mediaLinksInfo?.iPhone?.URL && (
                                      <a
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        href={mediaLinksInfo?.iPhone?.URL}
                                        aria-label="Download from App Store"
                                      >
                                        <img
                                          height="32px"
                                          className="login-store-icon1"
                                          src={Appstore}
                                          title="Appstore"
                                          alt="app-store"
                                        />
                                      </a>
                                    )}
                                    {mediaLinksInfo?.Android?.URL && (
                                      <a
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        href={mediaLinksInfo?.Android?.URL}
                                        aria-label="Download from Google Play"
                                      >
                                        <img
                                          height="32px"
                                          className="login-store-icon1"
                                          src={Googleplay}
                                          title="Googleplay"
                                          alt="googleplay"
                                        />
                                      </a>
                                    )}
                                  </p>
                                </>
                              )}
                          </Col>
                        )}
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      {/*Based on login we need to add this class login_padding */}
      {httpheader.getCNAME().includes('mybenefits') ||
      httpheader.getCNAME().includes('roundstone') ? (
        <></>
      ) : (
        <div className="copy-right">
          <Container>
            <Row>
              <Col>
                <div className="width-100 copy-right-title">
                  {branding?.Title}
                </div>
                <div className="copy-right-text">
                  {' '}
                  <span></span> {branding?.Copyright}{' '}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </div>
  );
}
